module.exports = __webpack_public_path__ + "assets/Phone.ecbcf902320bd58d3ca4393738babf47.svg";